import React from 'react';
import { useFeatureFlag } from 'js/sign-components/common/feature-flag';
import ProgressiveCheckoutSignInPage from './progressive-checkout-sign-in-page';
import SignInPage from './sign-in-page';

export default function SignInPageWrapper() {
  const isProgressiveCheckoutEligible = useFeatureFlag(
    'sign_services_20240325_progressive_checkout',
  );

  return isProgressiveCheckoutEligible ? (
    <ProgressiveCheckoutSignInPage />
  ) : (
    <SignInPage />
  );
}
